<template>
  <div class="match-center-pc">
    <div style="margin-top: 70px;">
      <div class="description-1">
        <div class="des">
          <div class="title">
            <div class="num">
              <img src="@comm/assets/matchcenter/01.png" alt="" />
            </div>
            <div class="name">专属官网 独立二级域名</div>
          </div>
          <div class="txt-contnet">
            <div>专属赛事官网 配套赛事报名系统，</div>
            <div>成绩发布系统 资格审查系统 支持各类表单下载</div>
            <div>-</div>
            <div>后勤服务系统 全面解决赛事衣、食、住、行</div>
            <div>-</div>
            <div>赛事宣传招商运营全流程管理，打造赛事品牌</div>
            <div>以“赛事+旅游+经济”理念</div>
            <div>深度挖掘赛事附加值，达到多方共赢</div>
          </div>
        </div>

        <div class="images">
          <div class="box" ref="box1">
            <Transition
              enter-active-class="animate__animated animate__fadeInTopRight animate__delay-2s"
              leave-active-class="animate__animated animate__fadeOutTopRight "
            >
              <div class="img-01" v-show="anim0101">
                <img src="https://static.daoba.com/pc/matchcenter/01-01.png" alt="" />
              </div>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__fadeInTopRight animate__delay-1s"
              leave-active-class="animate__animated animate__fadeOutTopRight "
            >
              <div class="img-02" v-show="anim0102">
                <img src="https://static.daoba.com/pc/matchcenter/01-02.png" alt="" />
              </div>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__fadeInTopRight "
              leave-active-class="animate__animated animate__fadeOutTopRight "
            >
              <div class="img-03" v-show="anim0103">
                <img src="https://static.daoba.com/pc/matchcenter/01-03.png" alt="" />
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <div class="dbg-2">
        <div class="description-2">
          <div class="images">
            <div class="box" ref="box2">
              <Transition
                enter-active-class="animate__animated animate__backInDown"
                leave-active-class="animate__animated animate__zoomOutRight "
              >
                <div class="img-01" v-if="anim0201">
                  <img src="https://static.daoba.com/pc/matchcenter/02-01.png" alt="" />
                </div>
              </Transition>
              <Transition
                enter-active-class="animate__animated animate__backInDown"
                leave-active-class="animate__animated animate__zoomOutRight "
              >
                <div class="img-02" v-show="anim0202">
                  <img src="https://static.daoba.com/pc/matchcenter/02-02.png" alt="" />
                </div>
              </Transition>

              <Transition
                enter-active-class="animate__animated animate__backInUp "
                leave-active-class="animate__animated animate__backOutUp "
              >
                <div class="img-03" v-show="anim0203">
                  <img src="https://static.daoba.com/pc/matchcenter/02-04.png" alt="" />
                </div>
              </Transition>

              <Transition
                enter-active-class="animate__animated animate__backInDown "
                leave-active-class="animate__animated animate__zoomOutRight "
              >
                <div class="img-04" v-show="anim0204">
                  <img src="https://static.daoba.com/pc/matchcenter/02-03.png" alt="" />
                </div>
              </Transition>
            </div>
          </div>
          <div class="des">
            <div class="title">
              <div class="num">
                <img src="@comm/assets/matchcenter/02.png" alt="" />
              </div>
              <div class="name">专属赛事小程序</div>
            </div>
            <div class="txt-contnet">
              <div>提供更加方便、快捷的赛事服务体验</div>
              <div>帮助参赛各方随时随地浏览赛事信息</div>
              <div>报名参赛、查询报名状态、</div>
              <div>获取比赛通知、完成成绩查询、进行技术分析</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dbg-3">
        <div class="description-3">
          <div class="des">
            <div class="left">
              <div class="title">
                <div class="num">
                  <img src="@comm/assets/matchcenter/03.png" alt="" />
                </div>
                <div class="name">支持所有赛制 智能报名</div>
              </div>
              <div class="txt-contnet">
                <div>适用于所有奥运项目及各类群众项目</div>
                <div>覆盖全部赛制</div>
                <div>数据记忆无需二次填写</div>
                <div>支持个人、团体和代表团报名，PC/移动端报名</div>
                <div>省去大量繁琐人工，100%规避错报漏报</div>
                <div>提高500%的工作效率</div>
                <div
                  class="ball"
                  v-for="(item, index) in ballList"
                  :key="index"
                  @click="handleBall(item, index)"
                  :class="ballIndex == index ? 'ball-active' : ''"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="triangle"></div>
          </div>

          <div class="images">
            <Transition
              enter-active-class="animate__animated animate__backInDown "
              leave-active-class="animate__animated animate__backOutDown "
            >
              <template v-if="ballIndex == 0 && anim0301">
                <div class="img-01">
                  <img src="https://static.daoba.com/pc/matchcenter/03-01.png" alt="" />
                </div>
              </template>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__backInDown "
              leave-active-class="animate__animated animate__backOutDown "
            >
              <template v-if="ballIndex == 0 && anim0301">
                <div class="img-02">
                  <img src="https://static.daoba.com/pc/matchcenter/03-02.png" alt="" />
                </div>
              </template>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__backInDown "
              leave-active-class="animate__animated animate__backOutDown "
            >
              <template v-if="ballIndex == 1">
                <div class="img-01">
                  <img src="https://static.daoba.com/pc/matchcenter/03-03.png" alt="" />
                </div>
              </template>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__backInDown "
              leave-active-class="animate__animated animate__backOutDown "
            >
              <template v-if="ballIndex == 1">
                <div class="img-02">
                  <img src="https://static.daoba.com/pc/matchcenter/03-04.png" alt="" />
                </div>
              </template>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__backInDown "
              leave-active-class="animate__animated animate__backOutDown "
            >
              <template v-if="ballIndex == 2">
                <div class="img-01">
                  <img src="https://static.daoba.com/pc/matchcenter/03-05.png" alt="" />
                </div>
              </template>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__backInDown "
              leave-active-class="animate__animated animate__backOutDown "
            >
              <template v-if="ballIndex == 2">
                <div class="img-02">
                  <img src="https://static.daoba.com/pc/matchcenter/03-06.png" alt="" />
                </div>
              </template>
            </Transition>
          </div>
        </div>
      </div>
      <div class="dbg-4">
        <div class="description-4">
          <div class="images">
            <div class="box" ref="box2">
              <Transition
                enter-active-class="animate__animated animate__backInLeft"
                leave-active-class="animate__animated animate__backOutRight "
              >
                <div class="img-01" v-if="anim0401">
                  <img src="https://static.daoba.com/pc/matchcenter/04-02.png" alt="" />
                </div>
              </Transition>
              <Transition
                enter-active-class="animate__animated animate__backInLeft"
                leave-active-class="animate__animated animate__backOutRight "
              >
                <div class="img-02" v-show="anim0402">
                  <img src="https://static.daoba.com/pc/matchcenter/04-01.png" alt="" />
                </div>
              </Transition>
            </div>
          </div>
          <div class="des">
            <div class="title">
              <div class="num">
                <img src="@comm/assets/matchcenter/04.png" alt="" />
              </div>
              <div class="name">资格审查与称重</div>
            </div>
            <div class="txt-contnet">
              <div>为组委会提供更专业便捷的审查流程</div>
              <div>配置各种功能 最大限度缩减工作量</div>
              <div>根据审查结果可修改运动员报名项目</div>
              <div>-</div>
              <div>重竞技项目，报名完成自动生成称重表</div>
              <div>现场快捷登记称重结果</div>
              <div>数据自动导入编排系统</div>
            </div>
          </div>
        </div>
      </div>
      <div class="description-5">
        <div class="des">
          <div class="title">
            <div class="num">
              <img src="@comm/assets/matchcenter/05.png" alt="" />
            </div>
            <div class="name">一键下载秩序册/智能参赛证</div>
          </div>
          <div class="txt-contnet">
            <div>一键生成参赛证和秩序册，多模板自动排版</div>
            <div>随时随地一键下载打印</div>
            <div>省去大量繁琐的人工工作</div>
            <div>-</div>
            <div>智能参赛证多模板选择</div>
            <div>展示信息排版支持自定义</div>
            <div>多角色可选</div>
            <div>扫码接收检录通知</div>
            <div>实时关注赛事进程和成绩发布</div>
          </div>
        </div>

        <div class="images">
          <div class="box" ref="box1">
            <Transition
              enter-active-class="animate__animated animate__fadeInTopRight animate__delay-2s"
              leave-active-class="animate__animated animate__fadeOutTopRight "
            >
              <div class="img-01" v-show="anim0501">
                <img src="https://static.daoba.com/pc/matchcenter/05-01.png" alt="" />
              </div>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__fadeInTopRight animate__delay-1s"
              leave-active-class="animate__animated animate__fadeOutTopRight "
            >
              <div class="img-02" v-show="anim0502">
                <img src="https://static.daoba.com/pc/matchcenter/05-02.png" alt="" />
              </div>
            </Transition>
            <Transition
              enter-active-class="animate__animated animate__fadeInTopRight "
              leave-active-class="animate__animated animate__fadeOutTopRight "
            >
              <div class="img-03" v-show="anim0503">
                <img src="https://static.daoba.com/pc/matchcenter/05-03.png" alt="" />
              </div>
            </Transition>
          </div>
        </div>
      </div>
      <div class="dbg-6">
        <div class="description-6">
          <div class="images">
            <div class="box" ref="box2">
              <Transition
                enter-active-class="animate__animated animate__backInLeft"
                leave-active-class="animate__animated animate__backOutRight "
              >
                <div class="img-01" v-if="anim0601">
                  <img src="https://static.daoba.com/pc/matchcenter/06-01.png" alt="" />
                </div>
              </Transition>
            </div>
          </div>
          <div class="des">
            <div class="title">
              <div class="num">
                <img src="@comm/assets/matchcenter/06.png" alt="" />
              </div>
              <div class="name">赛事赋能 挖掘赛事价值</div>
            </div>
            <div class="txt-contnet">
              <div>通过票务中心、赞助招商、直播打赏等运营功能</div>
              <div>帮助办赛机构解决了赛事运营难题</div>
              <div>提高赛事盈利能力</div>
              <div>道吧网强大的资源整合能力</div>
              <div>向全球商家推广赛事和宣传</div>
              <div>扩大赛事品牌影响力和商业价值</div>
            </div>
          </div>
        </div>
      </div>
      <div class="description-7">
        <div class="title">在道吧创赛，你将享有</div>
        <div>
          <TransitionGroup
            tag="div"
            class="join-list"
            enter-active-class="animate__animated animate__zoomIn"
            leave-active-class="animate__animated animate__zoomOut "
          >
            <div
              class="join-box"
              v-for="(item, index) in joinInfoList"
              :key="index"
              :class="[
                index == 0 ? 'borderfirst' : '',
                index == 2 ? 'bordertwo' : '',
                index == 3 ? 'borderthree' : '',
                index == 5 ? 'borderfive' : '',
              ]"
            >
              <div class="name">
                <div class="icon"><img :src="item.icon" alt="" /></div>
                <div>{{ item.name }}</div>
              </div>
              <div class="detail">
                <div class="line" v-for="(i, j) in item.detail" :key="j">
                  <div class="dot"></div>
                  <div class="txt">{{ i }}</div>
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'animate.css'
export default {
  name: 'matchCenterPc',
  props: {},
  data() {
    return {
      anim0101: false,
      anim0102: false,
      anim0103: false,
      anim0201: false,
      anim0202: false,
      anim0203: false,
      anim0204: false,

      anim0301: false,

      anim0401: false,
      anim0402: false,
      anim0501: false,
      anim0502: false,
      anim0503: false,
      anim0601: false,
      ballList: [
        { id: 1, name: '大球类' },
        { id: 2, name: '小球类' },
        { id: 3, name: '竞技类' },
      ],
      ballIndex: 0,
      joinInfoList: [
        {
          id: 1,
          name: '专属官网',
          icon: require('@daoba-match/assets/matchcenter/join-1.png'),
          detail: [
            '赛事日程，赛事新闻发布，组委会通讯录',
            '赛事线上报名渠道，赛事状态查看，参赛数据展示',
            '成绩发布系统，搭配电子竞赛设备可查看对局技术统计，奖牌统计、团体总分统计',
            '赛事精彩图片视频发布平台',
            '赛事招商，票务中心',
            '后勤服务系统，解决赛事衣食住行',
          ],
        },
        {
          id: 2,
          name: '专属小程序',
          icon: require('@daoba-match/assets/matchcenter/join-2.png'),
          detail: [
            '赛事日程，赛事新闻发布，组委会通讯录',
            '赛事线上报名渠道，查看报名状态',
            '成绩发布系统，搭配电子竞赛设备可查看对局技术统计，奖牌统计、团体总分统计',
            '赛事精彩图片视频发布平台',
            '赛事招商，票务中心',
            '后勤服务系统，解决赛事衣食住行',
            '订阅赛事检录通知',
            '赛事分享海报',
          ],
        },
        {
          id: 3,
          name: '智能报名',
          icon: require('@daoba-match/assets/matchcenter/join-3.png'),
          detail: [
            '支持各项目各赛制报名',
            '身份检索，智能匹配参赛项目',
            '信息复用，无需二次填写报名信息',
            '自主设定报名填写项目',
            '自主设定报名上传资料',
            '自主设定报名缴费项目，缴费方式',
            '可线上收缴报名费，购买保险',
            '参赛数据统计，一键下载报名表 ',
          ],
        },
        {
          id: 4,
          name: '资格审查与称重',
          icon: require('@daoba-match/assets/matchcenter/join-4.png'),
          detail: [
            '根据报名信息修改运动员报名项目',
            '报名完成自动生成称重表，一键下载运动员称重信息',
            '现场快捷登记称重结果',
            '数据自动导入编排系统',
          ],
        },
        {
          id: 5,
          name: '数据中心',
          icon: require('@daoba-match/assets/matchcenter/join-5.png'),
          detail: [
            '一键下载秩序册，支持PDF和WORD格式，多种版式可选，自定义内容模块',
            '一键下载智能参赛证PDF，自定义样式和内容',
            '参赛证可接入安保系统，运动员扫码入场',
            '参赛证可扫码进入小程序，实时查看赛事进程',
            '赛前奖牌计算，根据报名项目、人数生成奖牌数量，可分项目查看',
            '一键下载运动员参赛数据，多数据类型可选',
          ],
        },
        {
          id: 6,
          name: '赛事赋能',
          icon: require('@daoba-match/assets/matchcenter/join-6.png'),
          detail: [
            '平台助力提高赛事盈利能力，组委会自定义开通各项功能：',
            '票务中心，赛场入场券、景区门票发放',
            '广告招商，赛事线上线下广告位招商',
            '冠名赞助，开通赛事活动冠名和赞助渠道',
            '直播打赏，开通赛事直播和线上打赏功能',
            '商家入驻，酒店出行、周边美食美景资源置换',
          ],
        },
      ],
    }
  },
  components: {},
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    if (!this.anim0101) {
      this.anim0101 = true
      this.anim0102 = true
      this.anim0103 = true
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleBall(item, index) {
      this.ballIndex = index
    },
    handleScroll() {
      // const windowHeight = window.innerHeight
      // const box1Top = this.$refs.box1.offsetTop
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      console.log(111, scrollTop)
      if (scrollTop > 700 && !this.anim0201) {
        this.anim0201 = true
        this.anim0202 = true
        this.anim0203 = true
        this.anim0204 = true
      }
      if (scrollTop > 1300 && !this.anim0301) {
        this.anim0301 = true
      }
      if (scrollTop > 1900 && !this.anim0401) {
        this.anim0401 = true
        this.anim0402 = true
      }
      if (scrollTop > 2600 && !this.anim0501) {
        this.anim0501 = true
        this.anim0502 = true
        this.anim0503 = true
      }
      if (scrollTop > 3300 && !this.anim0601) {
        this.anim0601 = true
      }
    },
  },
  watch: {},
}
</script>

<style scoped lang="scss">
//01样式
.description-1 {
  width: 1200px;
  margin: 0 auto;
  height: 625px;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;

  .des {
    width: 354px;
    color: #333333;
    padding-top: 20px;
    box-sizing: border-box;
    .title {
      position: relative;
      font-size: 24px;
      margin-top: 35px;
      .num {
        width: 125px;
        height: 120px;
        color: #999999;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        font-weight: 600;
        margin-top: -20px;
        margin-bottom: 20px;
      }
    }
    .txt-contnet {
      margin-top: 100rpx;
      color: #333333;
      font-size: 16px;
      div {
        font-weight: 500;
        margin-bottom: 8px;
      }
    }
  }
  .images {
    width: 846px;
    box-sizing: border-box;
    position: relative;

    .img-01 {
      width: 830px;
      position: absolute;
      left: 0;
      bottom: 40px;
      opacity: 1;
      z-index: 10;
      img {
        width: 830px;
      }
    }

    .img-02 {
      width: 728px;
      position: absolute;
      left: 200px;
      bottom: 170px;
      z-index: 9;
      img {
        width: 728px;
      }
    }
    .img-03 {
      width: 620px;
      position: absolute;
      left: 400px;
      bottom: 300px;
      z-index: 8;
      img {
        width: 620px;
      }
    }
  }
}
.dbg-2 {
  width: 100%;
  background-image: url('https://static.daoba.com/pc/matchcenter/02-bg.png');
  background-size: 100% 630px;
  background-repeat: no-repeat;
  box-sizing: border-box;
  height: 630px;
  z-index: 20;
  .description-2 {
    width: 1200px;
    margin: 0 auto;
    height: 630px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;

    .des {
      width: 354px;
      color: #333333;
      padding-top: 50px;
      box-sizing: border-box;
      .title {
        position: relative;
        font-size: 24px;
        margin-top: 35px;
        .num {
          width: 125px;
          height: 120px;
          color: #999999;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          font-weight: 600;
          margin-top: -20px;
          margin-bottom: 20px;
        }
      }
      .txt-contnet {
        margin-top: 100rpx;
        color: #333333;
        font-size: 16px;
        div {
          font-weight: 500;
          margin-bottom: 8px;
        }
      }
    }
    .images {
      width: 846px;
      box-sizing: border-box;
      position: relative;
      box-sizing: border-box;
      .img-01 {
        width: 305px;
        height: 544px;
        position: absolute;
        left: 0;
        bottom: 20px;
        opacity: 1;
        z-index: 5;
        img {
          width: 305px;
        }
      }

      .img-02 {
        width: 305px;
        height: 338px;
        position: absolute;
        top: -30px;
        left: 260px;
        z-index: 6;
        img {
          width: 305px;
        }
      }
      .img-03 {
        width: 305px;
        height: 264px;
        position: absolute;
        left: 260px;
        bottom: -15px;
        z-index: 7;
        img {
          width: 305px;
        }
      }
      .img-04 {
        width: 305px;
        height: 505px;
        position: absolute;
        top: 20px;
        left: 520px;
        z-index: 7;
        img {
          width: 305px;
        }
      }
    }
  }
}
.dbg-3 {
  z-index: 30;
  background-image: linear-gradient(to right, #fff 50%, #f1f1f1 100%);
  .description-3 {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    background-image: linear-gradient(to right, #fff 0, #fff 544px, #f1f1f1 544px, #f1f1f1 1200px);
    height: 630px;
    position: relative;
    .des {
      width: 544px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      .left {
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;

        .title {
          width: 100%;
          font-size: 24px;
          margin-top: 35px;
          margin-bottom: 35px;
          .num {
            width: 125px;
            height: 120px;
            color: #999999;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .name {
            font-weight: 600;
            margin-top: -20px;
            // margin-bottom: 20px;
          }
        }
        .txt-contnet {
          margin-top: 100rpx;
          color: #333333;
          font-size: 16px;
          div {
            font-weight: 500;
            margin-bottom: 8px;
          }
        }
        .ball {
          width: 198px;
          height: 55px;
          line-height: 55px;
          cursor: pointer;
          color: #333333;
          font-weight: bold;
          text-align: center;
          margin-bottom: 20px;
          background-color: #f5f5f5;
        }
        .ball-active {
          background-color: #c4c4c4;
        }
      }
      .triangle {
        border-left: 190px solid transparent;
        border-bottom: 630px solid #f1f1f1;
      }
    }
    .images {
      width: 656px;
      height: 630px;
      position: absolute;
      right: 0;
      bottom: 0;
      display: flex;
      justify-content: flex-end;
      .img-01 {
        position: absolute;
        left: -250px;
        bottom: 0;
        z-index: 10;
      }
      .img-02 {
        position: absolute;
        left: 40px;
        bottom: -10px;
        z-index: 8;
        img {
          width: 785px;
          height: 518px;
        }
      }
    }
  }
}
.dbg-4 {
  width: 100%;
  background-image: url('https://static.daoba.com/pc/matchcenter/04-bg.png');
  background-size: 100% 630px;
  position: relative;
  z-index: 40;
  background-repeat: no-repeat;
  .description-4 {
    width: 1200px;
    margin: 0 auto;
    height: 625px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;

    height: 630px;
    .des {
      width: 354px;
      color: #fff;
      padding-top: 50px;
      box-sizing: border-box;
      .title {
        position: relative;
        font-size: 24px;
        margin-top: 35px;
        .num {
          width: 125px;
          height: 120px;
          color: #999999;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          font-weight: 600;
          margin-top: -20px;
          margin-bottom: 20px;
        }
      }
      .txt-contnet {
        margin-top: 100rpx;
        color: #fff;
        font-size: 16px;
        div {
          font-weight: 500;
          margin-bottom: 8px;
        }
      }
    }
    .images {
      width: 846px;
      box-sizing: border-box;
      position: relative;
      box-sizing: border-box;
      .img-01 {
        width: 820px;
        height: 566px;
        position: absolute;
        left: -200px;
        bottom: 20px;
        opacity: 1;
        z-index: 12;
        img {
          width: 820px;
        }
      }

      .img-02 {
        width: 472px;
        height: 255px;
        position: absolute;
        top: 0;
        left: 260px;
        z-index: 15;
        img {
          width: 472px;
        }
      }
    }
  }
}
.description-5 {
  width: 1200px;
  margin: 0 auto;
  height: 630px;
  box-sizing: border-box;
  z-index: 50;
  display: flex;
  justify-content: flex-start;

  .des {
    width: 354px;
    color: #333333;
    padding-top: 50px;
    box-sizing: border-box;
    .title {
      position: relative;
      font-size: 24px;
      margin-top: 35px;
      .num {
        width: 125px;
        height: 120px;
        color: #999999;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .name {
        font-weight: 600;
        margin-top: -20px;
        margin-bottom: 20px;
      }
    }
    .txt-contnet {
      margin-top: 100rpx;
      color: #333333;
      font-size: 16px;
      div {
        font-weight: 500;
        margin-bottom: 8px;
      }
    }
  }
  .images {
    width: 846px;
    box-sizing: border-box;
    position: relative;

    .img-01 {
      width: 339px;
      height: 179px;
      position: absolute;
      right: -140px;
      bottom: 160px;
      opacity: 1;
      z-index: 48;
      img {
        width: 339px;
      }
    }

    .img-02 {
      width: 661px;
      height: 398px;
      position: absolute;
      left: 300px;
      bottom: 100px;
      z-index: 46;
      img {
        width: 661px;
      }
    }
    .img-03 {
      width: 913px;
      height: 490px;
      position: absolute;
      left: 0;
      top: 10px;
      z-index: 45;
      img {
        width: 913px;
      }
    }
  }
}
.dbg-6 {
  width: 100%;
  background-image: url('https://static.daoba.com/pc/matchcenter/06-bg.png');
  background-size: 100% 630px;
  z-index: 40;
  background-repeat: no-repeat;
  .description-6 {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    height: 630px;
    z-index: 60;
    .des {
      width: 354px;
      color: #fff;
      padding-top: 50px;
      box-sizing: border-box;
      .title {
        position: relative;
        font-size: 24px;
        margin-top: 35px;
        .num {
          width: 125px;
          height: 120px;
          color: #999999;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          font-weight: 600;
          margin-top: -20px;
          margin-bottom: 20px;
        }
      }
      .txt-contnet {
        margin-top: 100rpx;
        color: #fff;
        font-size: 16px;
        div {
          font-weight: 500;
          margin-bottom: 8px;
        }
      }
    }
    .images {
      width: 846px;
      box-sizing: border-box;
      position: relative;
      box-sizing: border-box;
      .img-01 {
        width: 1037px;
        height: 468px;
        position: absolute;
        left: -200px;
        top: 30px;
        opacity: 1;
        z-index: 60;
        img {
          width: 1037px;
        }
      }
    }
  }
}
.description-7 {
  width: 1200px;
  height: 868px;
  margin: 0 auto;
  color: #333333;
  .title {
    height: 140px;
    font-size: 36px;
    font-weight: bold;
    text-align: center;
    padding-top: 50px;
  }
  .join-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    box-sizing: border-box;
    .join-box {
      width: 400px;
      height: 400px;
      box-sizing: border-box;
      background-image: url('https://static.daoba.com/pc/matchcenter/07-02.png');
      background-repeat: no-repeat;
      background-size: 100%;
      background-color: #fff;
      padding: 30px;
      .name {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 20px;
        .icon {
          margin-right: 10px;
          img {
            width: 36px;
            height: 36px;
          }
        }
      }
      .detail {
        width: 100%;
        .line {
          position: relative;
          margin-bottom: 15px;
          .dot {
            position: absolute;
            top: 8px;
            left: 15px;
            width: 6px;
            height: 6px;
            background-color: #333333;
          }
          .txt {
            padding-left: 30px;
            font-size: 14px;
          }
        }
      }
    }
    .join-box:hover {
      background-image: url('https://static.daoba.com/pc/matchcenter/07-03.png');
    }
    .borderfirst {
      border-radius: 20px 0 0 0;
      // background-image: url('https://static.daoba.com/pc/matchcenter/07-03.png');
    }
    .bordertwo {
      border-radius: 0 20px 0 0;
    }
    .borderthree {
      border-radius: 0 0 0 20px;
    }
    .borderfive {
      border-radius: 0 0 20px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/matchcenter/components/MatchCenterPc.vue